import React, { Component } from 'react';
import { Input, Icon, List, Button, Popconfirm } from 'antd';
import { MODAL_TYPES, ModalFactory } from 'components/ModalFactory';
import { PushNotification } from 'utils/PushNotification';

const { Search } = Input;
const ListItem = List.Item;
const AWS = require('aws-sdk');
const HTTP_PROTOCOL = 'http:';
const HTTPS_PROTOCOL = 'https:';
const AWS_REGION = 'sa-east-1';

const IMAGE_NOT_FOUND = 'Image not found!';
const IMAGE_ALREADY_EXISTS = 'Image already exists!';
const IMAGE_DELETED_SUCCESS = 'Image deleted success';
const OPS_WE_HAD_A_PROBLEM = 'Ops! We had a problem! See on the console.';

export class Images extends Component {

  formRef : any;

  state = {
    isLoading: false,
    isModalVisible: false,
    currentModal: '',
    editingRecord: {},
    isModalLoading: false,
    imageList: [],
    awsCredentials: {
      accessKeyId : '',
      secretAccessKey : '',
      sessionToken : '',
    },
    inputValue: ''
  }

  componentDidMount() {
    this.handleModalVisibility(true);
  }

  saveFormRef = (formRef: any) : void => {
    this.formRef = formRef;
  }

  getCredentials = () : void => {
    AWS.config.update({
      accessKeyId: this.state.awsCredentials.accessKeyId,
      secretAccessKey: this.state.awsCredentials.secretAccessKey,
      sessionToken: this.state.awsCredentials.sessionToken,
      region: AWS_REGION
    });

    AWS.config.getCredentials(function (error) {
      if (error) {
        PushNotification.error(error.stack)
      }
    });
  }

  setComponentLoading = (isLoading: boolean) : void => {
    this.setState({ isLoading });
  }

  handleDeleteItem = (item: any) : void => {
    const filteredImgs = this.state.imageList.filter(img => img !== item);
    this.setState({ imageList: filteredImgs });
  }

  handleOnOpenModal = () : void => {
    this.setState({
      currentModal: MODAL_TYPES.AWSCredentials,
      isModalVisible: true
    });
  }

  handleModalVisibility = (visibility: boolean) : void => {
    this.setState({ isModalVisible: visibility });
    if (!visibility) {
      this.setState({ editingRecord: {} });
    }
  }

  handleOnOkModal = () : void => {
    this.setState({ isModalLoading: true });

    const form = this.formRef.props.form;

    form.validateFields(async (err, values) => {
      if (err) {
        this.setState({ isModalLoading: false });
        return;
      }

      try {
        this.setState({ awsCredentials: values });
        form.resetFields();
        this.setState({ isModalVisible: false, editingRecord: {} });
        this.getCredentials();
      } catch (error) {
        PushNotification.error(OPS_WE_HAD_A_PROBLEM);
        throw error;
      } finally {
        this.setState({ isModalLoading: false });
      }
    });
  }

  isValidHttpUrl = (uri: string) : boolean => {
    let url;

    try {
      url = new URL(uri);
    } catch (_) {
      return false;
    }

    return url.protocol === HTTP_PROTOCOL || url.protocol === HTTPS_PROTOCOL;
  }

  onSearch = (imageUrl: string) : void => {
    if (imageUrl == undefined || imageUrl == '') {
      return;
    }

    const imgs = this.state.imageList;
    try {
      const image_url = decodeURIComponent(imageUrl);
      if (this.isValidHttpUrl(image_url)) {
        this.setComponentLoading(true);
        const existsImage = imgs.some(item => item == image_url);
        if (!existsImage) {
          imgs.push(image_url);
        } else {
          PushNotification.warnig(IMAGE_ALREADY_EXISTS);
        }
      } else {
        PushNotification.error(IMAGE_NOT_FOUND);
      }
    } catch (e) {
      PushNotification.error(IMAGE_NOT_FOUND);
    } finally {
      this.setState([...this.state.imageList, ...imgs]);
      this.setComponentLoading(false);
    }

    this.setState({ inputValue: String() });
  }

  deleteObjects = async () : Promise<void> => {
    const s3 = new AWS.S3();
    let imgs = this.state.imageList;

    for (var i = 0; i < this.state.imageList.length; i++) {
      const image = this.state.imageList[i];
      const arrayUrl = image.replace('https://', '').split('/');
      const bucket = arrayUrl[1];
      const key = arrayUrl[2] + '/' + arrayUrl[3];

      try {
        await s3.deleteObject({ Bucket: bucket, Key: key }).promise();
        PushNotification.success(IMAGE_DELETED_SUCCESS);
        imgs = imgs.filter(img => img !== image);
      } catch (error) {
        PushNotification.httpError(error);
      }
    }

    this.setState({ imageList: imgs });
  }

  render() {
    const { imageList, inputValue } = this.state;

    return (
      <div className="flex flex-wrap">
        <Button type="primary" icon="edit" onClick={this.handleOnOpenModal}>
          AWS Credentials
        </Button>
        <div className="tc w-100">
          <h1>
            <Icon type="delete" className="mr3" />
            Delete Sensitive Image
          </h1>
          <Search
            placeholder="Image url"
            enterButton="Search"
            size="large"
            style={{ width: 400 }}
            onSearch={this.onSearch}
            value={inputValue}
            onChange={(e) => this.setState({ inputValue: e.target.value })}
            allowClear
          />
          <List
            size="large"
            dataSource={imageList}
            renderItem={item => (
              <ListItem
                extra={<Button
                  icon="delete"
                  size="small"
                  onClick={() => this.handleDeleteItem(item)}
                />}
              >
                {item}
              </ListItem>
            )}
          />
          <Popconfirm
            disabled={imageList.length == 0}
            placement="top"
            title={'This action is IRREVERSIBLE. Are you sure?'}
            onConfirm={this.deleteObjects}
            okText="Continue"
            cancelText="Cancel"
          >
            <Button
              icon="delete"
              type="primary"
              style={{ background: 'red', color: 'white' }}
              disabled={imageList.length == 0}
            >
              Delete
            </Button>
          </Popconfirm>
        </div>

        <ModalFactory
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.isModalVisible}
          onCancel={() => this.handleModalVisibility(false)}
          onOk={() => this.handleOnOkModal()}
          loading={this.state.isModalLoading}
          type={MODAL_TYPES.AWSCredentials}
          record={this.state.editingRecord}
          maskClosable={false}
        />
      </div>
    )
  }
}
